import { useDebugValue, useEffect, useState } from 'react';

import { useQuery } from '@app/QueryClient';
import { apiTechnicians } from '@app/Services/TeamMembers';
import { TTechnician } from '@modules/TeamMembers/types';
import { useQueryString } from '@zeal/zeal-lib';

import { generatedKeys } from '../queryKeysFactory';

const { teamMembers } = generatedKeys;

export function useBranchTechnicians() {
	const [queryState] = useQueryString();
	const { branch } = queryState;

	const [teamList, setTeamList] = useState<any[]>([]);

	const q = useQuery({
		queryFn: apiTechnicians,
		queryKey: [
			teamMembers.branchTechnicians,
			{
				paginate: 0,
				branchId: branch,
			},
		],
		staleTime: Infinity,
		enabled: !!branch,
		onerror: (error: any) => {
			if (error?.status === 404) {
				return [];
			}
		},
	});

	const formatTechnicians = (d: any) => ({
		...d,
		label: d.name,
		value: d.uuid,
		resourceId: d.uuid,
	});

	const { data: teamData } = q;

	useEffect(() => {
		if (teamData) {
			const formattedData = teamData?.data?.map(formatTechnicians);
			setTeamList(formattedData);
		}
	}, [teamData, setTeamList]);

	useDebugValue(q);

	return { ...q, data: teamList as TTechnician[] };
}
